/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Application_Overview_Status_SavedInputs */

const en_landing_application_overview_status_saved = /** @type {(inputs: Landing_Application_Overview_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved`)
};

const de_landing_application_overview_status_saved = /** @type {(inputs: Landing_Application_Overview_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespeichert`)
};

const fr_landing_application_overview_status_saved = /** @type {(inputs: Landing_Application_Overview_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrée`)
};

const es_landing_application_overview_status_saved = /** @type {(inputs: Landing_Application_Overview_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardada`)
};

const it_landing_application_overview_status_saved = /** @type {(inputs: Landing_Application_Overview_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvata`)
};

const nl_landing_application_overview_status_saved = /** @type {(inputs: Landing_Application_Overview_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgeslagen`)
};

const pl_landing_application_overview_status_saved = /** @type {(inputs: Landing_Application_Overview_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisana`)
};

const fi_landing_application_overview_status_saved = /** @type {(inputs: Landing_Application_Overview_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tallennettu`)
};

const da_landing_application_overview_status_saved = /** @type {(inputs: Landing_Application_Overview_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemt`)
};

const sv_landing_application_overview_status_saved = /** @type {(inputs: Landing_Application_Overview_Status_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sparad`)
};

/**
* | output |
* | --- |
* | "Saved" |
*
* @param {Landing_Application_Overview_Status_SavedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_application_overview_status_saved = /** @type {((inputs?: Landing_Application_Overview_Status_SavedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Application_Overview_Status_SavedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_application_overview_status_saved(inputs)
	if (locale === "fr") return fr_landing_application_overview_status_saved(inputs)
	if (locale === "es") return es_landing_application_overview_status_saved(inputs)
	if (locale === "it") return it_landing_application_overview_status_saved(inputs)
	if (locale === "nl") return nl_landing_application_overview_status_saved(inputs)
	if (locale === "pl") return pl_landing_application_overview_status_saved(inputs)
	if (locale === "fi") return fi_landing_application_overview_status_saved(inputs)
	if (locale === "da") return da_landing_application_overview_status_saved(inputs)
	if (locale === "sv") return sv_landing_application_overview_status_saved(inputs)
	return en_landing_application_overview_status_saved(inputs)
});